import { getInviteCode } from "@hg/recall-frame"
import React, { FC, useState } from "react"

import { CodeInput } from "@/components/CodeInput"
import { Modal } from "@/components/Modal"
import OutlinedText from "@/components/OutlinedText"
import { i18n } from "@/i18n"
import { useInviteSubmit } from "../../Invite"

import styles from "./index.module.scss"

interface CodeInputModalProps {
    open: boolean
    onClose: () => void
    onSuccess?: () => void
}

export const CodeInputModal: FC<CodeInputModalProps> = ({
    open,
    onClose,
    onSuccess,
}) => {
    const [inviteCode, setInviteCode] = useState(getInviteCode())

    const submitInvite = useInviteSubmit(onSuccess)

    const clickHandler = () => {
        submitInvite(inviteCode)
    }

    return (
        <Modal
            onConfirm={clickHandler}
            open={open}
            onClose={onClose}
        >
            <div className={styles.inviteWrap}>
                <div className={styles.inputTitle}>
                    <OutlinedText
                        text={i18n.getRecall("record.code_input_title")}
                        fontSize={32}
                        strokeWidth={8}
                        fontFamily="a한글세상B"
                        strokeColor="#8E7355"
                        fillColor="#FEFAF6"
                    />
                </div>
                <CodeInput
                    value={inviteCode}
                    onChange={(val) => setInviteCode(val)}
                    placeholder={i18n.getRecall("invite.input_placeholder")}
                />
            </div>
        </Modal>
    )
}
